import React, {Component} from 'react';
import ReactModal from 'react-modal';
import classNames from 'classnames';
import './Modal.scss';

ReactModal.setAppElement('body');

class Modal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      hasCloseBottom: false
    }
  }

  componentWillMount() {

  }

  onAfterOpen(e) {
    // console.log('event', e);
    // console.log('modal', this.modal)
    // this.modal.addEventListener('wheel', (e) => {
    //   e.stopPropagation();
    // });
    // this.modal.addEventListener('mousewheel', (e) => {
    //   e.stopPropagation();
    // });
    //
    // this.modal.addEventListener('touchmove', (e) => {
    //   e.stopPropagation();
    // });
    let modalContent = this.modal.children[0]
    let rect = modalContent.getBoundingClientRect();

    this.setState({
      hasCloseBottom: rect.height > 1000
    })
  }

  render() {
    let {children, isOpen, title, size} = this.props;

    return (
      <ReactModal
        portalClassName="modal-portal"
        overlayClassName={classNames("modal-overlay", {fullscreen: this.props.fullscreen} )}
        className={classNames('modal-content', size, this.props.class)}
        closeTimeoutMS={300}
        isOpen={isOpen}
        onAfterOpen={this.onAfterOpen.bind(this)}
        overlayRef={ref => this.modal = ref}>
        <div className="modal-header">
          <div className='title'>{title}</div>
          <div className='close' onClick={() => this.props.onClose()}>
            <i className="fa fa-close"/>
          </div>
        </div>
        {children}
        {this.state.hasCloseBottom && (
          <div onClick={() => this.props.onClose()} className="close-modal-button">close</div>
        )}
      </ReactModal>
    )
  }
}

export default Modal;
